import React, { useEffect, useRef, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from 'react-i18next';
import HighlightsItem from '../../../../../Homepage/Highlights/HighlightsItem';

import icon1 from "../../../../../../assets/images/satellite/icon_pme.png";
import icon2 from "../../../../../../assets/images/satellite/icon_empresas.png";
import icon3 from "../../../../../../assets/images/satellite/icon_projeto.png";

const OutsourcingPilar11 = props => {

    const [inView, setInView] = useState(false);
    const ref = useRef(null);
    const checkInView = e => {
        if (!ref.current || (!e.target.scrollingElement && !e.target.documentElement)) {
            return;
        }
        let scrollingElement = e.target.scrollingElement ? e.target.scrollingElement : e.target.documentElement;

        let top = ref.current.offsetTop;
        const bottom = ref.current.clientHeight + top;
        top -= scrollingElement.clientHeight;
        const inV = top + 15 < scrollingElement.scrollTop && bottom > scrollingElement.scrollTop;
        if (inView !== inV) {
            setInView(inV);
        }
    }
    useEffect(() => {
        document.addEventListener('scroll', checkInView, true);

        return () => {
            document.removeEventListener('scroll', checkInView, true);

        }
    });

    return (
        <section id="outsourcing-pilar-section11" className="my pt-5 black-bg">
            <div className='white-shape'></div>
            <Container>
                <div className="title-triangle top-md fw-600"></div>
                <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingPilar:section-11.title')}</h2>
                <p className='mb-5'><Trans>{props.t('services:outsourcingPilar:section-11.text')}</Trans></p>
                <div className='highlights my mb-3 text-md-center'>
                    <Row className='justify-content-around'>
                        <HighlightsItem image={icon1} inView={inView} custom title={props.t('services:outsourcingPilar:section-11.1.title')} text={props.t('services:outsourcingPilar:section-11.1.text')} />
                        <HighlightsItem image={icon2} inView={inView} custom title={props.t('services:outsourcingPilar:section-11.2.title')} text={props.t('services:outsourcingPilar:section-11.2.text')} />
                        <HighlightsItem image={icon3} inView={inView} custom title={props.t('services:outsourcingPilar:section-11.3.title')} text={props.t('services:outsourcingPilar:section-11.3.text')} />
                    </Row>
                </div>
            </Container>
        </section>
    );
}


export default OutsourcingPilar11;